export default class {
  constructor({ page, perPage, total, count }) {
    this.page = parseInt(page, 10);
    this.perPage = parseInt(perPage, 10);
    this.total = parseInt(total, 10);
    this.count = parseInt(count, 10);
    this.totalPages = Math.ceil(total / perPage) || 1;
  }

  get first() {
    return this.page === 1;
  }

  get last() {
    return this.page === this.totalPages;
  }

  get prev() {
    return this.first ? 1 : this.page - 1;
  }

  get next() {
    return this.last ? this.totalPages : this.page + 1;
  }

  toJSON() {
    const { page, perPage, total, count, totalPages } = this;
    return { page, perPage, total, count, totalPages };
  }
}
